import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CustomerSentOrdersResponseNormalized } from '../../../../../../../store/customerDetail/types';

import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { Tablet } from './Tablet';

export interface SentOrderItemProps {
  order: CustomerSentOrdersResponseNormalized;
  onSelect: (order: CustomerSentOrdersResponseNormalized) => void;
}

export const SentOrderItem: React.FC<SentOrderItemProps> = (props) => {
  const responsiveComponent = useBreakpointValue({
    base: <Mobile {...props} />,
    sm: <Tablet {...props} />,
    lg: <Desktop {...props} />,
  });

  return responsiveComponent;
};
